import {
  Box,
  Button,
  Container,
  Typography,
} from "@mui/material";
import { LinkWithScroll } from "common/components/LinkWithScroll";
import React, { useContext } from "react";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";

function AccommodationImage({ data }) {
  const { language } = useContext(LanguageContext);

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        minWidth: { xs: "100%", md: "50vw" },
        minHeight: { xs: "55vh", md: "65vh" },
        cursor: "pointer",
        "&:hover .acc-bg": {
          transform: "scale(1.06)",
        },
        "&:hover .acc-overlay": {
          opacity: 0.55,
        },
      }}
    >
      {/* Background image */}
      <Box
        className="acc-bg"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${require(`assets/images/${data.image}`)})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "transform 0.8s ease",
        }}
      />

      {/* Gradient overlay */}
      <Box
        className="acc-overlay"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to top, rgba(33,3,6,0.7) 0%, rgba(33,3,6,0.2) 50%, rgba(33,3,6,0.1) 100%)",
          opacity: 0.45,
          transition: "opacity 0.5s ease",
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          minHeight: { xs: "55vh", md: "65vh" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            color="secondary"
            textAlign="center"
            sx={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 400,
              fontSize: { xs: "1.6rem", md: "1.8rem" },
              letterSpacing: "0.08em",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            {data.title}
          </Typography>
          <Box
            sx={{
              width: 40,
              height: "1px",
              background: "var(--clr-primary-light)",
              my: 2,
            }}
          />
          <Typography
            variant="body1"
            color="secondary"
            mb={3}
            textAlign="center"
            sx={{
              fontSize: { xs: "0.85rem", md: "0.9rem" },
              letterSpacing: "0.05em",
              opacity: 0.9,
            }}
          >
            {data.text}
          </Typography>
          <LinkWithScroll
            to={`/${language}/accommodations`}
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                borderRadius: 0,
                px: 4,
                py: 1,
                fontFamily: "'Lato', sans-serif",
                fontWeight: 400,
                letterSpacing: "0.12em",
                fontSize: "0.8rem",
                backgroundColor: "transparent",
                border: "1px solid var(--clr-primary-light)",
                color: "var(--clr-primary-light)",
                "&:hover": {
                  backgroundColor: "var(--clr-primary)",
                  borderColor: "var(--clr-primary)",
                  color: "#fff",
                },
                transition: "all 0.4s ease",
              }}
            >
              {language === "pt" ? "Saiba Mais" : "Learn More"}
            </Button>
          </LinkWithScroll>
        </Container>
      </Box>
    </Box>
  );
}

export default AccommodationImage;
